<template>
  <div id="layout" ref="layout">
    <my-header :class="{'hide': !showMenus}" :device-type="deviceType" v-if="deviceType=='lg'"></my-header>
    <my-header2 :class="{'hide': !showMenus}" :device-type="deviceType" v-else></my-header2>
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
    <my-footer @showCodeDialod="showCodeDialod"></my-footer>
    <div class="float_hover" @click="showMsgDialog">
      <img src="../assets/images2/float_hover@2x.png" alt="">
    </div>
    <!-- 留言弹窗 -->
    <el-dialog @close="close" :fullscreen="!['lg'].includes(deviceType)" customClass="form-dialog" :close-on-click-modal="false" :close-on-press-escape="false" title="留言咨询" :visible.sync="megDialogVisible" width="500px" top="5vh">
      <el-form ref="editForm" :rules="editRules" :model="formData" label-width="100px">
        <el-form-item
          v-for="(item, index) in formColumns"
          :key="`edit-dialog-item-${index}`"
          :label="item.name"
          :prop="item.key">
          <template v-if="item.key === 'type'">
            <el-select
              v-model="formData[item.key]"
              :placeholder="`请选择${item.name}`"
              filterable>
              <el-option
                v-for="options in businessList"
                :key="`form-role-${options.id}`"
                :value="options.id*1"
                :label="options.title">
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.key === 'desc'">
            <el-input type="textarea" v-model="formData[item.key]" maxlength="140" show-word-limit></el-input>
          </template>
          <template v-else>
            <el-input v-model="formData[item.key]" :placeholder="item.name" clearable></el-input>
          </template>
        </el-form-item>
        <div class="dialog-footer">
          <el-button type="primary" round @click="editSave()" :disabled="saving"><i v-if="saving" class="el-icon-loading"></i> 确认提交</el-button>
          <!-- <el-button @click="cancel()">取消</el-button> -->
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="codeDialogVisible"
      width="30%"
      class="codeDialog"
      center>
      <img :src="footerData.codeImgUrl" alt="">
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import MyHeader from '../components/header';
import MyHeader2 from '../components/header2';
import MyFooter from '../components/footer';
import { commitMessage, appMenu, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

  const formDefault = {
    name: '',
    mobile: '',
    city: '',
    email: '',
    company: '',
    type: '',
    content: '',
  };
  const mobileReg = /^[1]\d{10}$/
  /* 验证手机号码 */
  const validateMobile = (rule, value, callback) => {
  if (value === '' || value === undefined || value === null) {
    callback(new Error('请输入手机号码'));
  } else if ((!mobileReg.test(value)) && value !== '') {
    callback(new Error('请输入正确的手机号码'));
  } else {
    callback();
  }
}

  const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* 验证邮箱 */
  const validateEmail = (rule, value, callback) => {
  if (value === '' || value === undefined || value === null) {
    callback(new Error('请输入邮箱地址'));
  } else if ((!emailReg.test(value)) && value !== '') {
    callback(new Error('请输入正确的邮箱'));
  } else {
    callback();
  }
}
export default {
  name: 'App',
  data() {
    return {
      clientWidth: '',
      footerData: {
        contact: [
          {
            icon: '',
            laber: '全国服务热线',
            value: '800-830-5218',
            type: ''
          },
          {
            icon: require('../assets/images2/bottom_icon_business@2x.png'),
            laber: '商务合作',
            value: 'office@prodata.com.cn',
            type: '',
            content: '',
          },
          {
            icon: require('../assets/images2/bottom_icon_phone@2x.png'),
            laber: '联系电话',
            value: '020-89226336',
            type: '',
            content: '',
          },
          {
            icon: require('../assets/images2/bottom_icon_address@2x.png'),
            laber: '公司地址',
            value: '广州市广东奔腾达电子有限公司',
            type: '',
            content: '',
          },
        ],
        beian: '',
        beianUrl: '',
        codeImgUrl: ''
      },
      formData: JSON.parse(JSON.stringify(formDefault)),
      formColumns: [
        { key: 'name', name: '姓   名' },
        { key: 'mobile', name: '电   话', validator: validateMobile },
        { key: 'city', name: '城   市' },
        { key: 'email', name: '工作邮箱', validator: validateEmail },
        { key: 'company', name: '公司全称' },
        { key: 'type', name: '业务类型', type: 'select' },
        { key: 'content', name: '提交详情' },
      ],
      businessList: [],
      megDialogVisible: false,
      codeDialogVisible: false,
      saving: false,
      showMenus: true
    }
  },
  computed: {
    activeNav() {
      return this.$store.state.activeNav;
    },
    deviceType() {
      // let clientWidth = this.clientWidth;
      switch (true) {
        case (this.clientWidth > 1100):
          return 'lg';
          break;
        case (this.clientWidth > 992):
          return 'md';
          break;
        case (this.clientWidth > 768):
          return 'sm';
          break;
        default:
          return 'xs';
          break;
      }
    },
  },
  components: { MyHeader, MyHeader2, MyFooter },
  created() {
    this.editRules = this.createRules();
    this.getNavData();
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);  
    this.clientWidth = document.documentElement.clientWidth;
    this.vh = window.innerHeight;
    const that = this;
    window.onresize = () => {
      return (() => {
        that.clientWidth = document.body.clientWidth;
      })();
    };
    console.log('app--mounted--this.deviceType==', this.deviceType);
    this.$store.commit('deviceType', this.deviceType);
  },
  methods: {
    async init() {
      const res1 = await getAppInfo('key-bottom-phone-title');
      this.footerData.contact[0].laber = res1.data.baseData.content;
      console.log('app--res1==', res1);
      const res2 = await getAppInfo('key-bottom-phone');
      this.footerData.contact[0].value = res2.data.baseData.content;
      console.log('app--res2==', res2);
      const res3 = await getAppInfo('key-bottom-beian');
      this.footerData.beian = res3.data.baseData.content;
      console.log('app--res3==', res3);
      const res3_1 = await getAppInfo('key-bottom-url');
      this.footerData.beianUrl = res3_1.data.baseData.content;
      console.log('app--res3_1==', res3_1);


      const res4 = await getAppInfo('key-bottom-bd');
      this.footerData.contact[1].content = res4.data.baseData.content;
      console.log('app--res4==', res4);
      const res5 = await getAppInfo('key-bottom-contact');
      this.footerData.contact[2].content = res5.data.baseData.content;
      console.log('app--res5==', res5);
      const res6 = await getAppInfo('key-bottom-address');
      this.footerData.contact[3].content = res6.data.baseData.content;
      console.log('app--res6==', res6);

      const res7 = await getAppInfo('key-info-codeImgUrl');
      this.footerData.codeImgUrl = res7.data.baseData.content;
      console.log('app--res7==', res7);

      // const res3 = await getAppInfo('key-bottom-beian');
      // this.footerData.beiane = res3.data.baseData.content;
      // console.log('app--res3==', res3);
      // const res3 = await getAppInfo('key-bottom-beian');
      // this.footerData.beiane = res3.data.baseData.content;
      // console.log('app--res3==', res3);




      this.$store.commit('footerData', this.footerData)
    },
    async getNavData() {
      const res = await appMenu()
      this.businessList = res.data.businessList;
      console.log('this.businessList==', this.businessList);
      
      this.$store.commit('navTitles', res.data.baseData)
      this.$store.commit('businessList', res.data.businessList)
      this.$store.commit('cateLists', res.data.productCategoryList)
      console.log('app--this.cateList===', res.data.productCategoryList);
      
      // this.$fetch('/app/menu').then(res => {
      //   console.log('app--res==', res);
      //   this.$store.commit('navTitles', res.data.baseData)
      //   this.$store.commit('businessList', res.data.businessList)
      //   this.$store.commit('cateLists', res.data.productCategoryList)
      // })
    },
    handleScroll(){
      // 页面滚动距顶部距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 
                document.body.scrollTop
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if(scroll<0){
        console.log('handleScroll--上');
        
        this.showMenus = true;
      }else{
        console.log('handleScroll--下');

        this.showMenus = false;
      }
    },
    showMsgDialog() {
      console.log('app--showMsgDialog');
      this.megDialogVisible = true;
    },
    showCodeDialod(isShow) {
      console.log('showCodeDialod--isShow==', isShow);
      this.codeDialogVisible = isShow
    },
    // 生成form的Rules；
    createRules() {
      const editRules = {};
      this.formColumns.forEach(column => {
        if (column.optionable) {
          return true;
        }
        editRules[column.key] = [
          {
            required: true,
            message: `请${column.type && column.type == 'select' ? '选择' : '填写'}${column.name}`,
            trigger: ['blur', 'change']
          }
        ];
        if (column.validator) {
          editRules[column.key].push({
            validator: column.validator,
            trigger: ['blur', 'change']
          });
        }
      });
      return editRules;
    },
    editSave() {
      let payload = null;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          payload = JSON.parse(JSON.stringify(this.formData));
        }
      });
      if (payload === null || this.saving) {
        return null;
      }
      console.log('editSave--payload==', payload);
      
      this.saving = true;
      commitMessage(payload).then(res => {
        console.log('commitMessage--res==', res);
        if (res.code === 0) {
          this.megDialogVisible = false;
          this.saving = false;
          this.$message.success(res.msg)
        }

      }).catch(res => {
        console.log('commitMessage--catch--res==', res);
        this.saving = false;
        this.$message.error(res.msg)
      })
      // this.dialogVisible = false;
    },
    close() {
      this.dialogVisible = false;
      this.saving = false;
      this.formData = JSON.parse(JSON.stringify(formDefault));
      console.log('this.formData==', this.formData);
    },

  }
}
</script>

<style>
@import '../common/css/global.scss';

#layout {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue